/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './NavigationView.types.tsx';
import { withRefreshBlocker } from './withRefreshBlocker.tsx';
import { findViewBy, updateContainerState } from './updateContainerState.tsx';

export const deleteViewFromState = (viewUUID: string): Action<State, Props> =>
	withRefreshBlocker(async ({ setState, getState }, { cloudId, containerId, onSuccess }) => {
		if (
			!cloudId ||
			!containerId ||
			getState().containers[containerId]?.isLoading ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}

		if (!viewUUID) {
			return;
		}

		const { view } = findViewBy(
			getState().containers[containerId],
			(innerView) => innerView.id === viewUUID,
		);

		if (!view) {
			return;
		}

		setState(
			updateContainerState(getState(), containerId, {
				views: getState()
					.containers[containerId].views.filter((innerView) => innerView.id !== viewUUID)
					.map((childView) => {
						if (childView.views) {
							return {
								...childView,
								views: childView.views?.filter((innerView) => innerView.id !== viewUUID),
							};
						}
						return childView;
					}),
			}),
		);

		onSuccess?.('deleteViewFromState');
	});
